import { z } from 'zod'

export const createSignEmailSchema = (language = 'en') => {
  const fr = language.startsWith('fr')
  return z.object({
    email: z
      .string()
      .trim()
      .min(1, fr ? "L'e-mail est requis" : 'Email is required')
      .email(fr ? "Format d'e-mail invalide" : 'Invalid email format'),
    password: z
      .string()
      .trim()
      .min(1, fr ? 'Le mot de passe est requis' : 'Password is required')
      .min(8, fr ? 'Au moins 8 caractères' : 'At least 8 characters')
      .regex(/[0-9]/, fr ? 'Au moins un chiffre' : 'At least one digit'),
  })
}

export const createSignUpSchema = (language = 'en') => {
  const fr = language.startsWith('fr')
  return z
    .object({
      firstName: z.string().trim().min(1, fr ? 'Prénom requis' : 'First name required'),
      lastName: z.string().trim().min(1, fr ? 'Nom requis' : 'Last name required'),
      email: z
        .string()
        .trim()
        .min(1, fr ? "L'e-mail est requis" : 'Email is required')
        .email(fr ? "Format d'e-mail invalide" : 'Invalid email format'),
      password: z
        .string()
        .trim()
        .min(8, fr ? 'Au moins 8 caractères' : 'At least 8 characters')
        .regex(/[0-9]/, fr ? 'Au moins un chiffre' : 'At least one digit'),
      confirmPassword: z.string().trim().min(1),
      company: z.string().optional(),
      country: z.string().trim().min(1, fr ? 'Pays requis' : 'Country required'),
      city: z.string().trim().min(1, fr ? 'Ville requise' : 'City required'),
    })
    .refine((d) => d.password === d.confirmPassword, {
      path: ['confirmPassword'],
      message: fr ? 'Les mots de passe ne correspondent pas' : "Passwords don't match",
    })
}
